module.exports = __webpack_public_path__ + "static/img/ua.4e53686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ua.png
// module id = v0py
// module chunks = 18